import Repository from './repository'

const resource = '/exercises'
const imageResource = '/exercise-images'

export default {
  ExercicioGetById(id) {
    return Repository.get(`${resource}/${id}`)
  },
  ExercicioGetByGroupId(id) {
    return Repository.get(`${resource}/group/${id}`)
  },
  ExercicioGet() {
    return Repository.get(`${resource}`)
  },
  ExercicioPost(item) {
    return Repository.post(`${resource}`, item)
  },
  ExercicioPut(id, item) {
    return Repository.put(`${resource}/${id}`, item)
  },
  ExercicioDelete(exercicioId) {
    return Repository.delete(`${resource}/${exercicioId}`)
  },
  ExercicioGetImages(id) {
    return Repository.get(`${imageResource}/exercise/${id}`)
  },
  ExercicioAddImage(imageData) {
    return Repository.post(`${imageResource}`, imageData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  ExercicioDeleteImage(imageId) {
    return Repository.delete(`${imageResource}/${imageId}`)
  },
  ExercicioUpdateImage(imageId, imageData) {
    imageData.append('_method', 'PUT') // Adiciona o método PUT como parâmetro no FormData
    return Repository.post(`${imageResource}/${imageId}`, imageData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
